import BaseTypography from 'components/typography/BaseTypography';
import { reusableStyles } from 'ui-blocks/ReusableStyles';
import { Box } from '@mui/material';
import React, { useState } from 'react';
import { FaqsConfiq } from 'config/FaqsConfig';
import { colorPalette } from 'ui-blocks/ColorPalette';
import { ReactComponent as ArrowIcon } from 'assets/svg/arrow-down.svg';

export function FaqsSection() {
	const [isOpen, setIsOpen] = useState(new Set());
	const handleFaqClick = (faqQuestion) => {
		const isOpenSet = new Set(isOpen);
		if (isOpenSet.has(faqQuestion)) {
			isOpenSet.delete(faqQuestion);
		} else {
			isOpenSet.add(faqQuestion);
		}
		setIsOpen(isOpenSet);
	};
	return (
		<Box
			id="Faqs-section"
			sx={{ ...reusableStyles.flexColWithGap(2), color: 'colors.text_high', width: '100%' }}
		>
			<BaseTypography variant="d3_zodiak_regular" sx={{ marginBottom: '40px' }}>
				FAQs
			</BaseTypography>
			{FaqsConfiq.map((faq) => (
				<Box
					key={faq.question}
					sx={{
						...reusableStyles.flexColWithGap(0),
						borderTop: `0.5px solid ${colorPalette.text_medium}`,
					}}
				>
					<Box
						sx={{
							...reusableStyles.flexRow,
							justifyContent: 'space-between',
							paddingTop: '24px',
							paddingBottom: '24px',
							cursor: 'pointer',
						}}
						onClick={() => handleFaqClick(faq.question)}
					>
						<BaseTypography variant="t2_v3_regular" color="colors.text_high">
							{faq.question}
						</BaseTypography>
						<ArrowIcon
							style={{
								transform: isOpen.has(faq.question) ? 'rotate(180deg)' : 'rotate(0deg)',
								transition: 'transform 0.4s ease-in-out',
							}}
						/>
					</Box>

					<Box
						sx={{
							maxHeight: isOpen.has(faq.question) ? '500px' : '0px',
							overflow: 'hidden',
							transition: '0.15s ease-in-out',
							marginBottom: isOpen.has(faq.question) && '16px',
						}}
					>
						<BaseTypography
							variant="t2_v3_regular"
							sx={{
								opacity: isOpen.has(faq.question) ? 1 : 0,
								transition: 'opacity 0.4s ease-in-out',
								color: 'colors.text_medium',
							}}
						>
							{faq.answer}
						</BaseTypography>
					</Box>
				</Box>
			))}
		</Box>
	);
}
